export const Cuisines = [
  "24 Hour",
  "American",
  "Asian",
  "Asian Fusion",
  "Banting",
  "Bistro",
  "Breakfast",
  "Buffet",
  "Burgers",
  "Catering",
  "Chicken",
  "Chinese",
  "Coffee Shop",
  "Contemporary",
  "Cuban",
  "Deli",
  "European",
  "Fast Food",
  "French",
  "Fusion",
  "Gluten Free",
  "Greek",
  "Grill",
  "Halaal",
  "Health",
  "Ice Cream",
  "Indian",
  "International",
  "Italian",
  "Japanese",
  "Korean",
  "Kosher",
  "Local Deli",
  "Malay",
  "Mediterranean",
  "Mexican",
  "Middle Eastern",
  "Pasta",
  "Pizza",
  "Portuguese",
  "Pub",
  "Salads",
  "Sandwiches",
  "Seafood",
  "South African",
  "Steakhouse",
  "Sushi",
  "Sweet Treats",
  "Tapas",
  "Thai",
  "Turkish",
  "Vegan",
  "Vegetarian",
  "Wraps"
];



// WEBPACK FOOTER //
// ./src/mockAPI/sample-cuisine-list.js